import type { FirebaseIdentityPayload } from '../types';
import { useUserJourneyStore } from '~/stores/apostatudo/user-journey';

/**
 * Identidade GA4/Firebase empurrada pelo app nativo (boot / webPageReady /
 * AppState:active). `app_instance_id` e `platform` sao estaveis; o
 * `ga_session_id` chega fresco a cada push (expira ~30min) e nunca e
 * persistido — o store dropa no afterHydrate.
 */
export function handleFirebaseIdentity(payload: FirebaseIdentityPayload): void {
  useUserJourneyStore().setFirebaseIdentity({
    app_instance_id: payload.app_instance_id,
    platform: payload.platform,
    ga_session_id: payload.ga_session_id,
  });
}
